<script>
  import ClientType from '../components/Settings/ClientType.svelte';
  import RegistrationType from '../components/Settings/RegistrationType.svelte';
  import ProjectType from '../components/Settings/ProjectType.svelte';
  import SowType from '../components/Settings/SowType.svelte';
  import FundStrategy from '../components/Settings/FundStrategy.svelte';
  import CodeofEthics from '../components/Settings/CodeofEthics.svelte';
  import InternalProject from '../components/Settings/InternalProject.svelte';
  import ServiceProviderType from '../components/Settings/ServiceProviderType.svelte';
  import DeliveryVertical from '../components/Settings/DeliveryVertical.svelte';
  import AssociatedRegion from '../components/Settings/AssociatedRegion.svelte';
  import AlertModal from '../components/Alert/Alert.svelte';
  import { onMount, onDestroy } from 'svelte';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { client } from 'root/api/index.js';
  import { searchKeyByValue } from 'components/Helper.js';
  import ActivityType from 'components/Settings/ActivityType.svelte';

  export let id = 0;
  let units = undefined;
  let unitIds = {};
  let selectedUnit = { id: id, name: '' };
  let parentColumn = true;
  let codeofEthics = true;
  let serviceType = false;
  const selectedUnitData = () => {
    let unitKey = searchKeyByValue(units, 'id', id);
    if (unitKey != -1) {
      selectedUnit = units[searchKeyByValue(units, 'id', id)];
      parentColumn = unitIds.outsourced_cfo != selectedUnit.id;
      serviceType = unitIds.outsourced_cfo != selectedUnit.id;
      codeofEthics = unitIds.outsourced_cfo != selectedUnit.id;
      triggerList();
    }
  };

  $: units && id && selectedUnitData();
  // $: id && triggerList()

  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = getMasterData().units;
        unitIds = getMasterData().unitId;
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
  });

  let activeSection = 'v-pills-home-tab';

  let alertConfirm;
  function handleConfirmClick(event) {
    alertConfirm.onHandleConfirm();
  }
  function triggerList() {
    setTimeout(() => {
      var triggerTabList = [].slice.call(document.querySelectorAll('#v-pills-tab a'));
      triggerTabList.forEach(function (triggerEl) {
        triggerEl.addEventListener('shown.bs.tab', function (event) {
          activeSection = event.target.id;
        });
      });
    }, 100);
  }
  // onMount(() => {
  //     var triggerTabList = [].slice.call(document.querySelectorAll('#v-pills-tab a'))
  //     triggerTabList.forEach(function (triggerEl) {
  //     triggerEl.addEventListener('shown.bs.tab', function (event) {
  //         activeSection = event.target.id
  //     })
  //     })
  // })
</script>

<div class="d-flex flex-column h-100 p-3">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-4">
        <h2 class="page-title">Manage lists</h2>
      </div>
      <div class="col-md-4">
        <div class="selected-business text-center">
          <span
            ><img
              class="me-2"
              alt=""
              src="/images/building.svg"
            />Unit:
            <strong class="font-weight-500">{selectedUnit.name}</strong></span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="page-content card-content bg-white {selectedUnit.id === '' ? 'd-none' : ''}">
    <div class="d-flex align-items-start h-100">
      <div class="d-flex flex-column left-navigations h-100">
        <div class="h-100 page-content">
          <div
            class="nav nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link d-flex flex-row align-items-center active"
              id="v-pills-home-tab"
              data-bs-toggle="pill"
              href="#v-pills-home"
              role="tab"
              aria-controls="v-pills-home"
              aria-selected="true"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  ><path
                    d="M5.5 4.125H22V5.5H5.5V4.125ZM11 11V9.625H22V11H11ZM11 16.5V15.125H22V16.5H11ZM0 6.875V2.75H4.125V6.875H0ZM1.375 4.125V5.5H2.75V4.125H1.375ZM5.5 12.375V8.25H9.625V12.375H5.5ZM6.875 9.625V11H8.25V9.625H6.875ZM5.5 17.875V13.75H9.625V17.875H5.5ZM6.875 15.125V16.5H8.25V15.125H6.875Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Client Type</span></a
            >
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-profile-tab"
              data-bs-toggle="pill"
              href="#v-pills-profile"
              role="tab"
              aria-controls="v-pills-profile"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M6.875 4.125V2.75H11V4.125H6.875ZM12.375 2.75H20.625V4.125H12.375V2.75ZM0 6.875V1.375H5.5V6.875H0ZM1.375 2.75V5.5H4.125V2.75H1.375ZM6.875 11V9.625H11V11H6.875ZM12.375 11V9.625H20.625V11H12.375ZM0 13.75V8.25H5.5V13.75H0ZM1.375 9.625V12.375H4.125V9.625H1.375ZM6.875 17.875V16.5H11V17.875H6.875ZM12.375 17.875V16.5H20.625V17.875H12.375ZM0 20.625V15.125H5.5V20.625H0ZM1.375 16.5V19.25H4.125V16.5H1.375Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Registration Type</span>
            </a>
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-messages-tab"
              data-bs-toggle="pill"
              href="#v-pills-messages"
              role="tab"
              aria-controls="v-pills-messages"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M7.24775 2.64076C7.51844 2.64076 7.75003 2.66826 7.94252 2.72326C8.13501 2.77826 8.30946 2.85159 8.46586 2.94325C8.62226 3.03491 8.76061 3.12963 8.88092 3.2274C9.00123 3.32518 9.12154 3.4199 9.24184 3.51156C9.36215 3.60322 9.49449 3.6735 9.63886 3.72238C9.78323 3.77127 9.94865 3.80182 10.1351 3.81405H19.086C19.2484 3.81405 19.3988 3.8446 19.5372 3.90571C19.6755 3.96682 19.7958 4.04931 19.8981 4.1532C20.0004 4.25708 20.0846 4.38235 20.1507 4.52901C20.2169 4.67567 20.247 4.82845 20.241 4.98733V13.2003H19.086V4.98733H10.1351C9.94865 4.98733 9.78624 5.01483 9.64788 5.06982C9.50953 5.12482 9.37719 5.19815 9.25087 5.28981C9.12454 5.38148 9.00123 5.4762 8.88092 5.57397C8.76061 5.67174 8.62527 5.76646 8.47488 5.85812C8.3245 5.94979 8.15005 6.02006 7.95154 6.06895C7.75304 6.11783 7.51844 6.14839 7.24775 6.16061H2.91667V16.7202H11.0013V17.8934H1.76172V3.81405C1.76172 3.64905 1.7918 3.49628 1.85195 3.35573C1.9121 3.21518 1.99331 3.09297 2.09557 2.98908C2.19783 2.8852 2.32115 2.79965 2.46552 2.73243C2.60989 2.66521 2.76027 2.63465 2.91667 2.64076H7.24775ZM7.24775 4.98733C7.39211 4.98733 7.51844 4.97511 7.62671 4.95066C7.73499 4.92622 7.83425 4.8865 7.92448 4.8315C8.01471 4.7765 8.10193 4.7154 8.18614 4.64818C8.27036 4.58096 8.36661 4.49846 8.47488 4.40069C8.37262 4.30902 8.27938 4.22958 8.19517 4.16236C8.11095 4.09514 8.02072 4.03404 7.92448 3.97904C7.82823 3.92404 7.72898 3.88432 7.62671 3.85988C7.52445 3.83543 7.39813 3.82016 7.24775 3.81405H2.91667V4.98733H7.24775ZM12.1563 19.0667H17.9311V20.24H12.1563V19.0667ZM19.086 19.0667H20.241V20.24H19.086V19.0667ZM19.086 16.7202H20.241V17.8934H19.086V16.7202ZM12.1563 16.7202H17.9311V17.8934H12.1563V16.7202ZM19.086 14.3736H20.241V15.5469H19.086V14.3736ZM12.1563 14.3736H17.9311V15.5469H12.1563V14.3736Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Project</span></a
            >
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-deliveries-tab"
              data-bs-toggle="pill"
              href="#v-pills-deliveries"
              role="tab"
              aria-controls="v-pills-deliveries"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M7.24775 2.64076C7.51844 2.64076 7.75003 2.66826 7.94252 2.72326C8.13501 2.77826 8.30946 2.85159 8.46586 2.94325C8.62226 3.03491 8.76061 3.12963 8.88092 3.2274C9.00123 3.32518 9.12154 3.4199 9.24184 3.51156C9.36215 3.60322 9.49449 3.6735 9.63886 3.72238C9.78323 3.77127 9.94865 3.80182 10.1351 3.81405H19.086C19.2484 3.81405 19.3988 3.8446 19.5372 3.90571C19.6755 3.96682 19.7958 4.04931 19.8981 4.1532C20.0004 4.25708 20.0846 4.38235 20.1507 4.52901C20.2169 4.67567 20.247 4.82845 20.241 4.98733V13.2003H19.086V4.98733H10.1351C9.94865 4.98733 9.78624 5.01483 9.64788 5.06982C9.50953 5.12482 9.37719 5.19815 9.25087 5.28981C9.12454 5.38148 9.00123 5.4762 8.88092 5.57397C8.76061 5.67174 8.62527 5.76646 8.47488 5.85812C8.3245 5.94979 8.15005 6.02006 7.95154 6.06895C7.75304 6.11783 7.51844 6.14839 7.24775 6.16061H2.91667V16.7202H11.0013V17.8934H1.76172V3.81405C1.76172 3.64905 1.7918 3.49628 1.85195 3.35573C1.9121 3.21518 1.99331 3.09297 2.09557 2.98908C2.19783 2.8852 2.32115 2.79965 2.46552 2.73243C2.60989 2.66521 2.76027 2.63465 2.91667 2.64076H7.24775ZM7.24775 4.98733C7.39211 4.98733 7.51844 4.97511 7.62671 4.95066C7.73499 4.92622 7.83425 4.8865 7.92448 4.8315C8.01471 4.7765 8.10193 4.7154 8.18614 4.64818C8.27036 4.58096 8.36661 4.49846 8.47488 4.40069C8.37262 4.30902 8.27938 4.22958 8.19517 4.16236C8.11095 4.09514 8.02072 4.03404 7.92448 3.97904C7.82823 3.92404 7.72898 3.88432 7.62671 3.85988C7.52445 3.83543 7.39813 3.82016 7.24775 3.81405H2.91667V4.98733H7.24775ZM12.1563 19.0667H17.9311V20.24H12.1563V19.0667ZM19.086 19.0667H20.241V20.24H19.086V19.0667ZM19.086 16.7202H20.241V17.8934H19.086V16.7202ZM12.1563 16.7202H17.9311V17.8934H12.1563V16.7202ZM19.086 14.3736H20.241V15.5469H19.086V14.3736ZM12.1563 14.3736H17.9311V15.5469H12.1563V14.3736Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Delivery Vertical</span></a
            >
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-associated-tab"
              data-bs-toggle="pill"
              href="#v-pills-associated"
              role="tab"
              aria-controls="v-pills-associated"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M7.24775 2.64076C7.51844 2.64076 7.75003 2.66826 7.94252 2.72326C8.13501 2.77826 8.30946 2.85159 8.46586 2.94325C8.62226 3.03491 8.76061 3.12963 8.88092 3.2274C9.00123 3.32518 9.12154 3.4199 9.24184 3.51156C9.36215 3.60322 9.49449 3.6735 9.63886 3.72238C9.78323 3.77127 9.94865 3.80182 10.1351 3.81405H19.086C19.2484 3.81405 19.3988 3.8446 19.5372 3.90571C19.6755 3.96682 19.7958 4.04931 19.8981 4.1532C20.0004 4.25708 20.0846 4.38235 20.1507 4.52901C20.2169 4.67567 20.247 4.82845 20.241 4.98733V13.2003H19.086V4.98733H10.1351C9.94865 4.98733 9.78624 5.01483 9.64788 5.06982C9.50953 5.12482 9.37719 5.19815 9.25087 5.28981C9.12454 5.38148 9.00123 5.4762 8.88092 5.57397C8.76061 5.67174 8.62527 5.76646 8.47488 5.85812C8.3245 5.94979 8.15005 6.02006 7.95154 6.06895C7.75304 6.11783 7.51844 6.14839 7.24775 6.16061H2.91667V16.7202H11.0013V17.8934H1.76172V3.81405C1.76172 3.64905 1.7918 3.49628 1.85195 3.35573C1.9121 3.21518 1.99331 3.09297 2.09557 2.98908C2.19783 2.8852 2.32115 2.79965 2.46552 2.73243C2.60989 2.66521 2.76027 2.63465 2.91667 2.64076H7.24775ZM7.24775 4.98733C7.39211 4.98733 7.51844 4.97511 7.62671 4.95066C7.73499 4.92622 7.83425 4.8865 7.92448 4.8315C8.01471 4.7765 8.10193 4.7154 8.18614 4.64818C8.27036 4.58096 8.36661 4.49846 8.47488 4.40069C8.37262 4.30902 8.27938 4.22958 8.19517 4.16236C8.11095 4.09514 8.02072 4.03404 7.92448 3.97904C7.82823 3.92404 7.72898 3.88432 7.62671 3.85988C7.52445 3.83543 7.39813 3.82016 7.24775 3.81405H2.91667V4.98733H7.24775ZM12.1563 19.0667H17.9311V20.24H12.1563V19.0667ZM19.086 19.0667H20.241V20.24H19.086V19.0667ZM19.086 16.7202H20.241V17.8934H19.086V16.7202ZM12.1563 16.7202H17.9311V17.8934H12.1563V16.7202ZM19.086 14.3736H20.241V15.5469H19.086V14.3736ZM12.1563 14.3736H17.9311V15.5469H12.1563V14.3736Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Associated Region</span></a
            >
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-settings-tab"
              data-bs-toggle="pill"
              href="#v-pills-settings"
              role="tab"
              aria-controls="v-pills-settings"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M9.625 5.5H0V4.125H9.625V5.5ZM4.125 8.25H13.75V9.625H4.125V8.25ZM15.125 8.25H22V9.625H15.125V8.25ZM22 4.125V5.5H11V4.125H22ZM4.125 12.375H17.875V13.75H4.125V12.375ZM0 16.5H13.75V17.875H0V16.5Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Engagement Services</span></a
            >
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-fundStrategy-tab"
              data-bs-toggle="pill"
              href="#v-pills-fundStrategy"
              role="tab"
              aria-controls="v-pills-fundStrategy"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M12.375 1.375L17.875 6.875V20.625H2.75V13.75H4.125V19.25H16.5V8.25H11V2.75H4.125V6.43457L2.8252 9.29199H2.75V1.375H12.375ZM12.375 6.875H15.9414L12.375 3.30859V6.875ZM5.84375 10.1191L4.8125 12.3857H1.375V11.0107H3.93164L5.84375 6.81055L9.03418 13.793L10.5381 11.0107H13.75V12.3857H11.3652L8.9375 16.876L5.84375 10.1191Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Fund Strategy Name</span></a
            >
            {#if codeofEthics}
              <a
                class="nav-link d-flex flex-row align-items-center"
                id="v-pills-CodeofEthics-tab"
                data-bs-toggle="pill"
                href="#v-pills-CodeofEthics"
                role="tab"
                aria-controls="v-pills-CodeofEthics"
                aria-selected="false"
              >
                <div class="setting-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M20.5486 10.9785C20.5486 11.2865 20.4663 11.5729 20.3015 11.8379L15.199 19.8301C15.0486 20.0592 14.8553 20.2383 14.6189 20.3672C14.3826 20.4961 14.1248 20.5641 13.8455 20.5713H3.00663C2.78462 20.5713 2.57694 20.5319 2.38358 20.4531C2.19022 20.3743 2.02193 20.2598 1.8787 20.1094C1.73547 19.959 1.6173 19.7871 1.5242 19.5938C1.43111 19.4004 1.38814 19.1927 1.3953 18.9707V2.97559C1.3953 2.75358 1.43827 2.5459 1.5242 2.35254C1.61014 2.15918 1.72473 1.99089 1.86795 1.84766C2.01118 1.70443 2.18306 1.58984 2.38358 1.50391C2.5841 1.41797 2.79178 1.375 3.00663 1.375H13.8455C14.1176 1.375 14.3754 1.43945 14.6189 1.56836C14.8624 1.69727 15.0558 1.87988 15.199 2.11621L20.3015 10.1084C20.4663 10.3734 20.5486 10.6634 20.5486 10.9785ZM3.00663 19.1963H4.57499C4.62512 19.1104 4.73254 18.9313 4.89725 18.6592C5.06197 18.387 5.26249 18.0505 5.49881 17.6494C5.73514 17.2484 5.99654 16.8151 6.28299 16.3496C6.56945 15.8841 6.85591 15.4007 7.14237 14.8994C7.42883 14.3981 7.71171 13.9255 7.991 13.4814C8.2703 13.0374 8.51021 12.6257 8.71073 12.2461C8.91125 11.8665 9.08312 11.5693 9.22635 11.3545C9.36958 11.1396 9.43404 11.0143 9.41971 10.9785C9.41971 10.957 9.35526 10.8317 9.22635 10.6025C9.09745 10.3734 8.92915 10.0762 8.72147 9.71094C8.51379 9.3457 8.2703 8.93392 7.991 8.47559C7.71171 8.01725 7.42883 7.54102 7.14237 7.04688C6.85591 6.55273 6.56587 6.07292 6.27225 5.60742C5.97863 5.14193 5.71724 4.70508 5.48807 4.29688C5.25891 3.88867 5.05838 3.55566 4.88651 3.29785C4.71463 3.04004 4.60363 2.85742 4.5535 2.75H3.00663C2.94934 2.75 2.89562 2.77148 2.84549 2.81445C2.79536 2.85742 2.7703 2.91113 2.7703 2.97559V18.9707C2.7703 19.0352 2.79178 19.0889 2.83475 19.1318C2.87772 19.1748 2.93501 19.1963 3.00663 19.1963ZM6.17557 19.1963H9.35526C9.40539 19.1104 9.51639 18.9313 9.68827 18.6592C9.86014 18.387 10.0642 18.0505 10.3006 17.6494C10.5369 17.2484 10.8055 16.8115 11.1062 16.3389C11.407 15.8662 11.7042 15.3828 11.9978 14.8887C12.2915 14.3945 12.5815 13.9219 12.868 13.4707C13.1544 13.0195 13.4015 12.6077 13.6092 12.2354C13.8168 11.863 13.9923 11.5658 14.1355 11.3438C14.2788 11.1217 14.3468 11 14.3396 10.9785C14.3396 10.9642 14.2752 10.8424 14.1463 10.6133C14.0174 10.3841 13.8419 10.0905 13.6199 9.73242C13.3979 9.37435 13.1473 8.95898 12.868 8.48633C12.5887 8.01367 12.295 7.53744 11.9871 7.05762C11.6792 6.5778 11.382 6.0944 11.0955 5.60742C10.809 5.12044 10.5369 4.68359 10.2791 4.29688C10.0213 3.91016 9.81717 3.57357 9.66678 3.28711C9.51639 3.00065 9.40539 2.82161 9.33378 2.75H6.15409L10.5691 10.1514C10.7195 10.402 10.7947 10.6777 10.7947 10.9785C10.7947 11.1217 10.7768 11.2614 10.741 11.3975C10.7052 11.5335 10.6479 11.666 10.5691 11.7949L6.17557 19.1963ZM19.1844 10.9785C19.1844 10.957 19.1163 10.8353 18.9803 10.6133C18.8442 10.3913 18.6652 10.0977 18.4432 9.73242C18.2211 9.36719 17.9633 8.95898 17.6697 8.50781C17.3761 8.05664 17.0753 7.58756 16.7674 7.10059C16.4594 6.61361 16.1551 6.13737 15.8543 5.67188C15.5535 5.20638 15.2742 4.77669 15.0164 4.38281C14.7586 3.98893 14.5473 3.65951 14.3826 3.39453C14.2179 3.12956 14.1033 2.95052 14.0389 2.85742C13.9887 2.78581 13.9243 2.75 13.8455 2.75H10.9451L15.4676 10.1406C15.5463 10.2695 15.6072 10.4056 15.6502 10.5488C15.6932 10.6921 15.7146 10.8353 15.7146 10.9785C15.7146 11.2793 15.6359 11.5586 15.4783 11.8164L10.9666 19.1963H13.8455C13.9243 19.1963 13.9887 19.1605 14.0389 19.0889C14.089 19.0029 14.2 18.8239 14.3719 18.5518C14.5437 18.2796 14.7586 17.9502 15.0164 17.5635C15.2742 17.1768 15.5499 16.7471 15.8435 16.2744C16.1372 15.8018 16.4451 15.3255 16.7674 14.8457C17.0896 14.3659 17.3868 13.9004 17.659 13.4492C17.9311 12.998 18.1889 12.5898 18.4324 12.2246C18.6759 11.8594 18.8585 11.5693 18.9803 11.3545C19.102 11.1396 19.17 11.0143 19.1844 10.9785Z"
                      fill=""
                    /></svg
                  >
                </div>
                <span>Code of Ethics</span></a
              >
            {/if}
            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-InternalProject-tab"
              data-bs-toggle="pill"
              href="#v-pills-InternalProject"
              role="tab"
              aria-controls="v-pills-InternalProject"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><g clip-path="url(#clip0)"
                    ><path
                      d="M20.625 6.87488C20.8184 6.87488 20.9974 6.91069 21.1621 6.9823C21.3268 7.05392 21.4701 7.1506 21.5918 7.27234C21.7135 7.39409 21.8138 7.5409 21.8926 7.71277C21.9714 7.88465 22.0072 8.06369 22 8.24988V20.6249H2.75V15.1249H0V1.37487C0 1.18151 0.0358073 1.00248 0.107422 0.837765C0.179036 0.673051 0.275716 0.529821 0.397461 0.408076C0.519206 0.286332 0.666016 0.186071 0.837891 0.107295C1.00977 0.0285187 1.1888 -0.00728862 1.375 -0.000127155H6.53125C6.85352 -0.000127155 7.12923 0.0320994 7.3584 0.0965527C7.58756 0.161006 7.79525 0.246943 7.98145 0.354365C8.16764 0.461787 8.32878 0.57279 8.46484 0.687374C8.60091 0.801957 8.74772 0.91296 8.90527 1.02038C9.06283 1.1278 9.22038 1.21016 9.37793 1.26745C9.53548 1.32474 9.73242 1.36055 9.96875 1.37487H17.875C18.0684 1.37487 18.2474 1.41068 18.4121 1.4823C18.5768 1.55391 18.7201 1.65059 18.8418 1.77234C18.9635 1.89408 19.0638 2.04089 19.1426 2.21277C19.2214 2.38464 19.2572 2.56368 19.25 2.74988V6.87488H20.625ZM1.375 1.37487V2.74988H6.53125C6.70312 2.74988 6.85352 2.73555 6.98242 2.70691C7.11133 2.67826 7.22949 2.63171 7.33691 2.56726C7.44434 2.50281 7.54818 2.43119 7.64844 2.35241C7.7487 2.27364 7.86328 2.17696 7.99219 2.06238C7.87044 1.95495 7.75944 1.86185 7.65918 1.78308C7.55892 1.7043 7.4515 1.63269 7.33691 1.56823C7.22233 1.50378 7.10417 1.45723 6.98242 1.42859C6.86068 1.39994 6.71029 1.38204 6.53125 1.37487H1.375ZM2.75 13.7499V6.87488C2.75 6.68152 2.78581 6.50249 2.85742 6.33777C2.92904 6.17306 3.02572 6.02983 3.14746 5.90808C3.26921 5.78634 3.41602 5.68608 3.58789 5.6073C3.75977 5.52853 3.9388 5.49272 4.125 5.49988H9.28125C9.60352 5.49988 9.87923 5.53211 10.1084 5.59656C10.3376 5.66101 10.5452 5.74695 10.7314 5.85437C10.9176 5.96179 11.0824 6.0728 11.2256 6.18738C11.3688 6.30196 11.512 6.41297 11.6553 6.52039C11.7985 6.62781 11.9561 6.71017 12.1279 6.76746C12.2998 6.82475 12.4967 6.86056 12.7188 6.87488H17.875V2.74988H9.96875C9.74675 2.74988 9.55339 2.7821 9.38867 2.84656C9.22396 2.91101 9.06641 2.99695 8.91602 3.10437C8.76562 3.21179 8.61882 3.32279 8.47559 3.43738C8.33236 3.55196 8.17122 3.66296 7.99219 3.77039C7.81315 3.87781 7.60547 3.96016 7.36914 4.01746C7.13281 4.07475 6.85352 4.11056 6.53125 4.12488H1.375V13.7499H2.75ZM10.7422 7.56238C10.6204 7.45496 10.5094 7.36186 10.4092 7.28309C10.3089 7.20431 10.2015 7.13269 10.0869 7.06824C9.97233 7.00379 9.85417 6.95724 9.73242 6.92859C9.61068 6.89995 9.46029 6.88204 9.28125 6.87488H4.125V8.24988H9.28125C9.45312 8.24988 9.60352 8.23556 9.73242 8.20691C9.86133 8.17827 9.97949 8.13172 10.0869 8.06727C10.1943 8.00281 10.2982 7.9312 10.3984 7.85242C10.4987 7.77365 10.6133 7.67697 10.7422 7.56238ZM20.625 8.24988H12.7188C12.4967 8.24988 12.3034 8.28211 12.1387 8.34656C11.974 8.41102 11.8164 8.49695 11.666 8.60438C11.5156 8.7118 11.3688 8.8228 11.2256 8.93738C11.0824 9.05197 10.9212 9.16297 10.7422 9.27039C10.5632 9.37781 10.3555 9.46017 10.1191 9.51746C9.88281 9.57475 9.60352 9.61056 9.28125 9.62489H4.125V19.2499H20.625V8.24988Z"
                      fill=""
                    /></g
                  ><defs
                    ><clipPath id="clip0"
                      ><rect
                        width="22"
                        height="22"
                        fill="white"
                      /></clipPath
                    ></defs
                  ></svg
                >
              </div>
              <span>Internal Projects</span></a
            >
            {#if serviceType}
              <a
                class="nav-link d-flex flex-row align-items-center"
                id="v-pills-ServiceProviderType-tab"
                data-bs-toggle="pill"
                href="#v-pills-ServiceProviderType"
                role="tab"
                aria-controls="v-pills-ServiceProviderType"
                aria-selected="false"
              >
                <div class="setting-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 22H19V20C18.9997 19.7349 18.8943 19.4807 18.7068 19.2932C18.5193 19.1057 18.2651 19.0003 18 19H14C13.7349 19.0003 13.4807 19.1057 13.2932 19.2932C13.1057 19.4807 13.0003 19.7349 13 20V22H11V20C11.0008 19.2046 11.3171 18.442 11.8796 17.8796C12.442 17.3171 13.2046 17.0008 14 17H18C18.7954 17.0008 19.558 17.3171 20.1204 17.8796C20.6829 18.442 20.9992 19.2046 21 20V22Z"
                      fill=""
                    />
                    <path
                      d="M16 16C15.3078 16 14.6311 15.7947 14.0555 15.4101C13.4799 15.0256 13.0313 14.4789 12.7664 13.8394C12.5015 13.1999 12.4322 12.4961 12.5673 11.8172C12.7023 11.1383 13.0356 10.5146 13.5251 10.0251C14.0146 9.53564 14.6383 9.2023 15.3172 9.06725C15.9961 8.9322 16.6999 9.00152 17.3394 9.26642C17.9789 9.53133 18.5256 9.97993 18.9101 10.5555C19.2947 11.1311 19.5 11.8078 19.5 12.5C19.4989 13.4279 19.1299 14.3176 18.4737 14.9737C17.8176 15.6299 16.9279 15.9989 16 16V16ZM16 11C15.7033 11 15.4133 11.088 15.1666 11.2528C14.92 11.4176 14.7277 11.6519 14.6142 11.926C14.5007 12.2001 14.4709 12.5017 14.5288 12.7926C14.5867 13.0836 14.7296 13.3509 14.9393 13.5607C15.1491 13.7704 15.4164 13.9133 15.7074 13.9712C15.9983 14.0291 16.2999 13.9994 16.574 13.8858C16.8481 13.7723 17.0824 13.58 17.2472 13.3334C17.412 13.0867 17.5 12.7967 17.5 12.5C17.4995 12.1023 17.3413 11.7211 17.0601 11.4399C16.7789 11.1587 16.3977 11.0005 16 11V11Z"
                      fill=""
                    />
                    <path
                      d="M30.414 17.414C30.7889 17.0389 30.9996 16.5303 30.9996 16C30.9996 15.4697 30.7889 14.961 30.414 14.586L24.627 8.79899L27.527 5.93699C27.9547 6.04348 28.4057 6.00581 28.8098 5.82983C29.214 5.65386 29.5488 5.34941 29.7622 4.96374C29.9757 4.57806 30.0559 4.13272 29.9904 3.6968C29.9249 3.26089 29.7173 2.85878 29.4 2.55287C29.0826 2.24696 28.6731 2.05434 28.2351 2.00491C27.7971 1.95548 27.355 2.052 26.9774 2.27949C26.5999 2.50698 26.3079 2.85272 26.1469 3.26308C25.9859 3.67343 25.9649 4.12545 26.087 4.54899L23.213 7.38499L17.414 1.58499C17.0389 1.21005 16.5303 0.99942 16 0.99942C15.4697 0.99942 14.961 1.21005 14.586 1.58499L8.79899 7.37399L5.93699 4.47199C6.04292 4.04414 6.0047 3.59329 5.82825 3.18938C5.6518 2.78548 5.34698 2.45109 4.96109 2.2381C4.5752 2.02511 4.1298 1.94542 3.694 2.0114C3.2582 2.07737 2.85635 2.28533 2.55079 2.603C2.24524 2.92067 2.05306 3.3303 2.00408 3.76833C1.95509 4.20637 2.05203 4.64833 2.27986 5.02565C2.50768 5.40298 2.85367 5.69456 3.26413 5.85518C3.67459 6.0158 4.12658 6.03647 4.54999 5.91399L7.38499 8.78699L1.58499 14.586C1.21005 14.961 0.99942 15.4697 0.99942 16C0.99942 16.5303 1.21005 17.0389 1.58499 17.414L7.38499 23.213L4.54999 26.086C4.12748 25.9643 3.67662 25.9854 3.2673 26.146C2.85798 26.3065 2.51307 26.5977 2.28601 26.9742C2.05896 27.3507 1.96245 27.7916 2.01144 28.2286C2.06044 28.6655 2.2522 29.0741 2.55701 29.391C2.86181 29.7079 3.26264 29.9154 3.69736 29.9813C4.13207 30.0473 4.57641 29.968 4.96148 29.7557C5.34655 29.5435 5.65085 29.2102 5.82722 28.8074C6.00359 28.4046 6.04217 27.9549 5.93699 27.528L8.79899 24.628L14.586 30.414C14.961 30.7889 15.4697 30.9996 16 30.9996C16.5303 30.9996 17.0389 30.7889 17.414 30.414L23.214 24.615L26.086 27.451C25.9643 27.8735 25.9854 28.3244 26.146 28.7337C26.3065 29.143 26.5977 29.4879 26.9742 29.715C27.3507 29.942 27.7916 30.0385 28.2286 29.9895C28.6655 29.9405 29.0741 29.7488 29.391 29.444C29.7079 29.1392 29.9154 28.7383 29.9813 28.3036C30.0473 27.8689 29.968 27.4246 29.7557 27.0395C29.5435 26.6544 29.2102 26.3501 28.8074 26.1738C28.4046 25.9974 27.9549 25.9588 27.528 26.064L24.628 23.201L30.414 17.414ZM16 29L2.99999 16L16 2.99999L29 16L16 29Z"
                      fill=""
                    />
                  </svg>
                </div>
                <span>Service Provider Type</span></a
              >
            {/if}

            <a
              class="nav-link d-flex flex-row align-items-center"
              id="v-pills-ActivityType-tab"
              data-bs-toggle="pill"
              href="#v-pills-ActivityType"
              role="tab"
              aria-controls="v-pills-activity"
              aria-selected="false"
            >
              <div class="setting-icon">
                <svg
                  class="me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M6.875 4.125V2.75H11V4.125H6.875ZM12.375 2.75H20.625V4.125H12.375V2.75ZM0 6.875V1.375H5.5V6.875H0ZM1.375 2.75V5.5H4.125V2.75H1.375ZM6.875 11V9.625H11V11H6.875ZM12.375 11V9.625H20.625V11H12.375ZM0 13.75V8.25H5.5V13.75H0ZM1.375 9.625V12.375H4.125V9.625H1.375ZM6.875 17.875V16.5H11V17.875H6.875ZM12.375 17.875V16.5H20.625V17.875H12.375ZM0 20.625V15.125H5.5V20.625H0ZM1.375 16.5V19.25H4.125V16.5H1.375Z"
                    fill=""
                  /></svg
                >
              </div>
              <span>Activity Type</span>
            </a>
          </div>
        </div>
      </div>

      <div
        class="tab-content w-100 h-100 d-flex flex-column"
        id="v-pills-tabContent"
      >
        <div
          class="tab-pane page-content fade show active"
          id="v-pills-home"
          role="tabpanel"
          aria-labelledby="v-pills-home-tab"
        >
          {#if activeSection === 'v-pills-home-tab'}
            <ClientType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
              parentColumn={parentColumn}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-profile"
          role="tabpanel"
          aria-labelledby="v-pills-profile-tab"
        >
          {#if activeSection === 'v-pills-profile-tab'}
            <RegistrationType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-messages"
          role="tabpanel"
          aria-labelledby="v-pills-messages-tab"
        >
          {#if activeSection === 'v-pills-messages-tab'}
            <ProjectType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-deliveries"
          role="tabpanel"
          aria-labelledby="v-pills-deliveries-tab"
        >
          {#if activeSection === 'v-pills-deliveries-tab'}
            <DeliveryVertical
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-associated"
          role="tabpanel"
          aria-labelledby="v-pills-associated-tab"
        >
          {#if activeSection === 'v-pills-associated-tab'}
            <AssociatedRegion
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-settings"
          role="tabpanel"
          aria-labelledby="v-pills-settings-tab"
        >
          {#if activeSection === 'v-pills-settings-tab'}
            <SowType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>

        <div
          class="tab-pane page-content fade"
          id="v-pills-fundStrategy"
          role="tabpanel"
          aria-labelledby="v-pills-fundStrategy-tab"
        >
          {#if activeSection === 'v-pills-fundStrategy-tab'}
            <FundStrategy
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>
        {#if codeofEthics}
          <div
            class="tab-pane page-content fade"
            id="v-pills-CodeofEthics"
            role="tabpanel"
            aria-labelledby="v-pills-CodeofEthics-tab"
          >
            {#if activeSection === 'v-pills-CodeofEthics-tab'}
              <CodeofEthics
                unitId={selectedUnit.id}
                bind:this={alertConfirm}
              />
            {/if}
          </div>
        {/if}

        <div
          class="tab-pane page-content fade"
          id="v-pills-InternalProject"
          role="tabpanel"
          aria-labelledby="v-pills-InternalProject-tab"
        >
          {#if activeSection === 'v-pills-InternalProject-tab'}
            <InternalProject
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>
        <div
          class="tab-pane page-content fade"
          id="v-pills-ServiceProviderType"
          role="tabpanel"
          aria-labelledby="v-pills-ServiceProviderType-tab"
        >
          {#if activeSection === 'v-pills-ServiceProviderType-tab'}
            <ServiceProviderType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>
        <div
          class="tab-pane page-content fade"
          id="v-pills-ActivityType"
          role="tabpanel"
          aria-labelledby="v-pills-activityType-tab"
        >
          {#if activeSection === 'v-pills-ActivityType-tab'}
            <ActivityType
              unitId={selectedUnit.id}
              bind:this={alertConfirm}
            />
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
<AlertModal
  title="Delete"
  message="Are you sure?"
  on:handleConfirm={handleConfirmClick}
/>

<style lang="scss">
  .selected-business {
    background-color: $light-blue-color;
    display: inline;
    padding: 5px 11px;
    border-radius: 5px;
  }
  .left-navigations {
    flex: 0 0 200px;
    max-width: 200px;
    background: rgba($input-border-color, 0.1);
    a {
      transition: all 0.15s ease;
      color: $lead-color;
      border-radius: 0;
      padding: 15px 15px;
      position: relative;
      width: 100%;
      &.active {
        background-color: rgba($blue-color, 0.1);
        color: $blue-color;
        svg {
          fill: $blue-color;
        }
        &:before {
          content: '';
          width: 3px;
          background: $blue-color;
          position: absolute;
          left: 0px;
          top: 0px;
          height: 100%;
        }
      }
      &:hover {
        background-color: rgba($blue-color, 0.1);
        color: $blue-color;
        svg {
          fill: $blue-color;
        }
        &:before {
          content: '';
          width: 3px;
          background: $blue-color;
          position: absolute;
          left: 0px;
          top: 0px;
          height: 100%;
        }
      }
      svg {
        fill: $lead-color;
      }
      .setting-icon {
        width: 30px;
        height: 20px;
      }
    }
  }
</style>
